module.exports = __webpack_public_path__ + "static/media/90s.49baef6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/90s.png
// module id = 336
// module chunks = 0